import moment from 'moment'
import { formatToBRL } from 'brazilian-values'

export function formatDecimal (value) {
  return formatToBRL(value).replace('R$', '')
}

export function formatPercent (value) {
  return formatToBRL(value).replace('R$', '') + ' %'
}

export function formatCurr (value) {
  return formatToBRL(value)
}

export function parseMoneyValue (value) {
  if (value === null || value === undefined || value === '') {
    return 0
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0
  }

  let normalized = String(value).trim().replace(/[^\d,.-]/g, '')
  if (!normalized) {
    return 0
  }

  const hasComma = normalized.includes(',')
  const hasDot = normalized.includes('.')

  if (hasComma && hasDot) {
    const commaIndex = normalized.lastIndexOf(',')
    const dotIndex = normalized.lastIndexOf('.')

    normalized = commaIndex > dotIndex
      ? normalized.replace(/\./g, '').replace(',', '.')
      : normalized.replace(/,/g, '')
  } else if (hasComma) {
    normalized = normalized.replace(',', '.')
  } else if (hasDot && !/\.\d{1,2}$/.test(normalized)) {
    normalized = normalized.replace(/\./g, '')
  }

  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? parsed : 0
}

export function formatDate (value) {
  if (!value) {
    return null
  }

  const [year, month, day] = value.split('-')

  if (day) {
    return `${day}/${month}/${year}`
  } else if (month) {
    return `${month}/${year}`
  } else {
    return year
  }
}

export function removeFormatDate (value) {
  if (!value) {
    return null
  }

  const [day, month, year] = value.split('/')

  return `${year}-${month}-${day}`
}

export function formatDateTime (value) {
  if (!value) {
    return null
  }

  return moment(new Date(value).toISOString()).format('DD/MM/YYYY hh:mm')
}

export function formatTime (value) {
  if (!value) {
    return null
  }

  return value.substring(0, 5)
}
